import { Scale, FileText, Gavel, Landmark, Building2 } from "lucide-react";

export const CASE_TYPES = [
  { id: "financial", label: "دعاوی مالی", icon: Scale },
  { id: "nonFinancial", label: "غیرمالی، خانوادگی و حسبی", icon: FileText },
  { id: "criminal", label: "امور کیفری", icon: Gavel },
  { id: "execution", label: "امور اجرایی", icon: Landmark },
  {
    id: "specialized",
    label: "مراجع اختصاصی غیرقضایی (صرفاً مالیات)",
    icon: Building2,
  },
];

export const TERMINATION_OPTIONS = [
  { id: "none", label: "پرونده با صدور رأی خاتمه یافته" },
  {
    id: "voidBeforeDefense",
    label: "قرار ابطال دادخواست، پیش از پاسخ و دفاع (۱/۴ مرحله بدوی)",
  },
  {
    id: "voidAfterDefense",
    label: "قرار ابطال دادخواست، پس از پاسخ و دفاع (۱/۲ مرحله بدوی)",
  },
  {
    id: "lapseBeforeDefense",
    label: "قرار سقوط دعوای تجدیدنظر، پیش از پاسخ و دفاع (۱/۴ مرحله تجدیدنظر)",
  },
  {
    id: "lapseAfterDefense",
    label: "قرار سقوط دعوای تجدیدنظر، پس از پاسخ و دفاع (۱/۲ مرحله تجدیدنظر)",
  },
];
